import { create } from "zustand";
import axios from "axios";

const useDepartmentStore = create((set) => ({
  departmentList: [],
  loading: false,
  error: null,

  getDepartmentList: async (company) => {
    set({ loading: true, error: null });
    try {
      const accessToken = localStorage.getItem("accessToken");
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/departments?company=${company}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      set({ departmentList: response.data?.data || [], loading: false });
      // console.log("Department List from Zustand Store", response.data?.data);
    } catch (err) {
      console.error(err);
      set({ error: err.message, loading: false });
    }
  },
}));

export default useDepartmentStore;
